// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__2fO0j","inputSuccess":"FieldCurrencyInput_inputSuccess__wQico","inputError":"FieldCurrencyInput_inputError__spQh-"};